import { styled } from "@mui/material/styles";

export const BSPH3 = styled("h3")`
  font-family: "Inter", var(--bigspring-primary-font);
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: 0.0025em;
  margin: 0;
`;
